

































































































































































































import Vue from 'vue'
import BFormInputLimited from '@/components/input_limited/BFormInputLimited.vue';
import BFormTextareaLimited from '@/components/input_limited/BFormTextareaLimited.vue';
import ProjectList from './dashboard/Projects.vue'
import CreateProject from './dashboard/CreateProject.vue'
import HiddenProjectList from './dashboard/HiddenProjectList.vue'
import Project from '@/models/Project'
import store from '@/store/store'
import { mapGetters } from 'vuex'
import SubscriptionPanel from '@/components/payment/SubscriptionPanel.vue';
import SupportForm from '@/components/support/SupportForm.vue'
import { BvModalEvent } from 'bootstrap-vue';
import { not } from 'vuelidate/lib/validators';
import User from '../models/User';

export default Vue.extend(
{
	refs: ['createProjectComponent', 'projectList'],
	data()
	{
		return {
			cpKey: 0,
			code: '',
			failureAlert: <String | null>null,
			projectToCopy: <Project | null>null,
			copyGroupsAndMembers: false,
			copyOnSubscribe: false,
			titleReplacement: '',
			descriptionReplacement: '',
			deepCopyMode: false,
			overrideTitle: false,
			isCopying: false,
			overrideDescription: false,
			modalKey: 0,
			startingSelectedPlan: null,
		}
	},
	components: 
	{
		ProjectList,
		CreateProject,
		HiddenProjectList,
		SubscriptionPanel,
		SupportForm,
		BFormInputLimited,
		BFormTextareaLimited
	},
	mounted()
	{
		if (this.isLTI)
		{
			if (!this.isLeavingPage())
			{
				this.$router.push(`/app/connect/${this.ltiTargetProject}`);
			}
			return;
		}

		let timer = setInterval(() =>
		{
			if (this.$refs.projectList)
			{
				this.$forceUpdate();
				clearInterval(timer);
			}
		}, 16);

		if (this.user.trialing && this.user.trialExpiration != null)
		{
			const daysLeft =
				Math.max(1, Math.ceil((this.user.trialExpiration.getTime() - (new Date()).getTime()) / (1000*60*60*24)));
			if (daysLeft <= 3)
			{
				this.$bvToast.toast(`Your trial ends in less than ${daysLeft} day${(daysLeft > 1) ? 's' : ''}.`,
				{
					title: 'Trial Ending Soon',
					variant: 'warning',
					autoHideDelay: 5000
				});
			}
		}

		if (!(this.user.isSubscribed) && !(this.user.trialing) && this.user.trialExpiration != null)
		{
			const daysExpired = 
				Math.floor(((new Date()).getTime() - this.user.trialExpiration.getTime()) / (1000*60*60*24));
			const notified = localStorage.getItem('trial-end-notified');
			if (!notified || daysExpired <= 5)
			{
				localStorage.setItem('trial-end-notified', 'true');
				this.$bvToast.toast('Your trial ended. Subscribe to restore premium features!',
				{
					title: 'Trial Ended',
					href: "/app/profile",
					variant: 'warning',
					autoHideDelay: 5000
				});
			}
		}
	},
	computed:
	{
		...mapGetters([
			'checkProjectTimelineForceWrite',
			'projects'
		]),
		isLTI()
		{
			return store.state.isLTI;
		},
		ltiTargetProject()
		{
			return store.state.ltiTargetProjectID;
		},
		oneProjectLimit()
		{
			const user : User = this.user;
			const projects : Map<string, Project> = (this as any).projects;
			return (!user.isSubscribed && !user.trialing && projects.size > 0);
		},
	},
	methods:
	{
		supportModalSubmit(modal : BvModalEvent)
		{
			modal.preventDefault();
			this.$nextTick(()=>{
				(this.$refs['supportForm'] as SupportForm).submit();
			})
		},
		isLeavingPage()
		{
			return (window as any).isUnloading;
		},
		copyProjectTemplate(project : Project)
		{
			++this.cpKey;
			this.$nextTick(() => 
			{
				(this.$refs.deepCopyModal as any).hide();
				this.openCreateProjectModal();
				this.$nextTick(() =>
				{
					(this.$refs.createProjectComponent as CreateProject).copyProject(project);
				});
			});
		},
		async deepCopyProject(subCreateRequest: any | undefined = undefined)
		{
			if (this.projectToCopy == null)
				return;

			this.isCopying = true;
			try
			{
				let bodyFormData = new FormData();
				bodyFormData.append('copyGroupsAndMembers', `${this.copyGroupsAndMembers}`);
				if (this.overrideTitle && this.titleReplacement.length > 0) 
					bodyFormData.append('titleReplacement', this.titleReplacement);
				if (this.overrideDescription && this.descriptionReplacement.length > 0) 
					bodyFormData.append('descriptionReplacement', this.descriptionReplacement);
				if (subCreateRequest != null)
					bodyFormData.append('subCreateRequest', subCreateRequest);
				let resp = await this.$http.post(`projects/deepcopy?project=${this.projectToCopy.pid}`, bodyFormData);
				if (resp.data.error)
				{
					throw { response: resp };
				}
				else
				{
					this.$bvToast.toast(this.projectToCopy.name + ' has been copied successfully.',
					{
						title: 'Project Copied',
						variant: 'success',
						autoHideDelay: 5000
					});
					this.resetCopyModalState();
				}
			}
			catch (err)
			{
				this.failureAlert = err.response.data.error
				console.error(err.response.data.error);
				return;
			}
			finally
			{
				this.isCopying = false;
			}
			
			(this.$refs.deepCopyModal as any).hide();
			// TODO: Reset context
			(this as any).$refs.projectList.refresh();
		},
		copyProject(project : Project)
		{
			if (this.projectToCopy !== project)
			{
				this.resetCopyModalState();
				this.projectToCopy = project;
			}
			if ((this as any).checkProjectTimelineForceWrite(project.group))
			{
				(this.$refs.deepCopyModal as any).show();
				this.deepCopyMode = false;
			}
			else
			{
				this.copyProjectTemplate(project);
			}
		},
		async createOrCopyUpgradedProject(subCreateRequest: any | undefined)
		{
			if (this.copyOnSubscribe)
			{
				await this.deepCopyProject(subCreateRequest); 
			}
			else
			{
				await this.createProject(this.$refs.createProjectComponent as CreateProject, subCreateRequest); 
			}

			(this.$refs.subscriptionModal as any).hide();
			this.refreshProjects();
		},
		async deepCopyProjectOrUpgradedProject()
		{
			if (this.projectToCopy)
			{
				if (this.user.isSubscribed && !this.copyGroupsAndMembers)
				{
					await this.deepCopyProject();
				}
				else
				{
					this.copyOnSubscribe = true;
					(this.$refs.subscriptionModal as any).show();
				}
			}
		},
		createUpgradedProject()
		{
			this.copyOnSubscribe = false;
			(this.$refs.subscriptionModal as any).show();
		},
		resetCopyModalState()
		{
			this.deepCopyMode = false;
			this.copyGroupsAndMembers = false;
			this.titleReplacement = '';
			this.descriptionReplacement = '';
			this.overrideTitle = false;
			this.overrideDescription = false;
		},
		refreshProjects()
		{
			this.failureAlert = null;
			(this as any).$refs.projectList.refresh();
		},
		clickJoinProject() : void
		{
			this.failureAlert = null;
			this.code = '';
			(this.$refs.joinProjectModal as any).show();		
		},
		async joinProject()
		{
			try	
			{
				let resp = await this.$http.post(`invite?code=${this.code}`);
				(this.$refs.joinProjectModal as any).hide();
				this.refreshProjects();
				if (resp.data && resp.data.result)
				{
					this.$bvToast.toast(resp.data.result, 
					{
						title: 'Join Project Result',
						autoHideDelay: 5000
					});
				}
			}
			catch (err)
			{
				this.failureAlert = err.response.data.error;
			}
		},
		async createProject(context: CreateProject, subCreateRequest: any | undefined)
		{
			try
			{
				// if (!this.user.isSubscribed && !this.user.isAdmin && subCreateRequest == null
				// 	&& this.projects.size > 0)
				// {
				// 	alert('You already have one Project. Subscribe and become a premium user or create an Upgraded Project!');
				// 	// TODO: replace with modal
				// }
				const endpoint = 
					`createproject?name=${
						context.projectName}&description=${
							context.projectDescription}&mappins=${
								JSON.stringify(context.projectMapNodes)}&data=${
									JSON.stringify(context.projectData)}`;
				let resp = await this.$http.post(endpoint, ((subCreateRequest == undefined) ? {} : subCreateRequest));
				if (resp.data.error)
				{
					throw { response: resp };
				}
				else
				{
					this.$bvToast.toast(context.projectName + ' has been created successfully.',
					{
						title: 'Project Created',
						variant: 'success',
						autoHideDelay: 5000
					});
				}
			}
			catch (err)
			{
				this.failureAlert = err.response.data.error;
				return;
			}
			
			this.closeCreateProjectModal();
			// TODO: Reset context
			(this as any).$refs.projectList.refresh();
		},
		showHiddenProjects()
		{
			(this.$refs as any).hiddenProjectModal.show();

			if (this.$refs.hiddenProjectList)
			{
				let ref = this.$refs.hiddenProjectList as HiddenProjectList;
				ref.refresh();
			}

			setTimeout(() => {
				this.$nextTick(() =>
				{
					(this.$refs.hiddenProjectFocus as HTMLElement).focus();
				});
			}, 50);
		},
		shouldGetEduDiscount()
    	{
        	return this.user.eduEligibilityOverride || this.user.email.endsWith('.edu');
		},
		openCreateProjectModal()
		{
			this.startingSelectedPlan = null;
			(this.$refs.createProjectModal as any).show();
		},
		closeCreateProjectModal()
		{
			//this.startingSelectedPlan = null;	//i decided not to this afer all because a b-alert would change before the modal was actually closed (Matt 4/9/2021)
			(this.$refs.createProjectModal as any).hide();
		}
	}
})
